import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RenderIfDirective } from './render-if.directive';

@NgModule({
  declarations: [RenderIfDirective],
  imports: [CommonModule],
  exports: [RenderIfDirective],
})
export class DirectivesModule {}
